import { Pipe, PipeTransform } from "@angular/core";

/**
 * Converte os valores de um objeto em array.
 */
@Pipe({
    name: "toArray"
})
export class ToArrayPipe implements PipeTransform {

    transform(value: Object): Object[] {
        if (!value) {
            return [];
        }

        return Object.values(value);
    }
}
